.c-suggestions__entry,
    .c-suggestions__entry:active,
    .c-suggestions__entry:focus,
    .c-suggestions__entry:hover {
      /* override default anchor styles */
      color: #27272a;
    }
    .c-suggestions__entry {

    cursor: pointer;
    display: block;
    padding: 0 0.4rem;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-tap-highlight-color: #2563eb;
    width: 100%;
}
    .c-suggestions__entry em {
      text-decoration: underline;
      font-style: normal;
    }
    .c-suggestions__entry__label {
      font-size: 0.875rem;
      line-height: 1.25rem;
}
    .c-suggestions__entry__details {
      font-size: 0.75rem;
      line-height: 1rem;
      --tw-text-opacity: 1;
      color: rgb(113 113 122 / var(--tw-text-opacity, 1));
      margin-top: -0.125rem;
}
    .c-suggestions__entry__selected {
      visibility: hidden;
      font-size: 0.875rem;
      line-height: 1.25rem;
      display: flex;
      align-items: center;
      --tw-text-opacity: 1;
      color: rgb(37 99 235 / var(--tw-text-opacity, 1));
      padding-left: 0.25rem;
      padding-right: 0.5rem;
}
    .c-suggestions__entry[data-highlighted] {
      background-color: #dbeafe;
    }
    .c-suggestions__entry[data-selected] .c-suggestions__entry__label {
      font-weight: 700;
}
    .c-suggestions__entry[data-selected] .c-suggestions__entry__selected {
      visibility: visible;
}
    .c-suggestions__entry[data-type='group'] .c-suggestions__entry__selected {
      display: none;
}
    .c-suggestions__entry[data-type='group'] {
      color: #71717a;
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 1.25rem;
      padding-left: 0.75em;
      cursor: default;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  .c-suggestions__no-entries {
    padding: 0.5em;
    color: #52525b;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    overflow: hidden;
    white-space: nowrap;
  }
  .c-suggestions__search {
    padding: 0.5em 0 0.5em 0;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
    position: relative;
  }
  .c-suggestions__search input {
      width: 100% !important;
      font-size: 0.875rem;
      line-height: 1.25rem;
      padding: 0.3em 0.5em 0.3em 2.3em;
    }
  .c-suggestions__search input, .c-suggestions__search input:focus {
        border: none;
        box-shadow: none;
        outline: none;
      }
  .c-suggestions__search-icon {
    position: absolute;
    left: 0.75em;
    height: 100%;
    top: 0;
    display: flex;
    align-items: center;
  }
  .c-suggestions__search-icon::after {
      width: 0.8em;
      height: 0.8em;
      opacity: 0.5;
      /* FontAwesome magnifying-glass */
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z'/></svg>");
      background-repeat: no-repeat;
      content: "";
      display: block;
    }

/*# sourceMappingURL=data:application/json;base64,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 */